import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class TrinityResultHeader extends Component {
  render() {
    const { open, statInfo, wholeSubject, subjectCondition } = this.props;
    return (
      <div className="trinity_result_header_big_box">
        <div className="trinity_result_header_box">
          <div className="fl trinity_result_header_sl_box">
            <div>
              选科：{wholeSubject[subjectCondition[0]]}{" "}
              {wholeSubject[subjectCondition[1]]}{" "}
              {wholeSubject[subjectCondition[2]]}
            </div>
            <div>
              学考：
              <span className={statInfo["A"] === 0 ? "display_none" : ""}>
                {statInfo["A"]}A{" "}
              </span>
              <span className={statInfo["B"] === 0 ? "display_none" : ""}>
                {statInfo["B"]}B{" "}
              </span>
              <span className={statInfo["C"] === 0 ? "display_none" : ""}>
                {statInfo["C"]}C{" "}
              </span>
              <span className={statInfo["D"] === 0 ? "display_none" : ""}>
                {statInfo["D"]}D{" "}
              </span>
              <span className={statInfo["E"] === 0 ? "display_none" : ""}>
                {statInfo["E"]}E{" "}
              </span>
            </div>
          </div>
          <div className="fr trinity_result_header_info_box">
            <div onClick={() => open()} className="fl ">
              说明
            </div>
            <div className="trinity_result_header_triangle fr"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default TrinityResultHeader;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/components/TrinityResultHeader/index.js